import React from 'react'
import type {ComponentPropsWithRef, CSSProperties, ReactNode} from 'react'
import {DisclosureContext} from './disclosure-context'
import {CollapsibleRegion} from './CollapsibleRegion'

export interface DisclosurePanelProps extends Omit<ComponentPropsWithRef<'div'>, 'className' | 'style' | 'children'> {
  labelledBy?: boolean
  className?: string
  style?: CSSProperties
  children: ReactNode
}

export const DisclosurePanel = ({
  labelledBy = false,
  className,
  style,
  children,
  ref,
  ...rest
}: DisclosurePanelProps) => {
  const disclosureContextValue = React.use(DisclosureContext)

  if (!disclosureContextValue) throw new Error('Disclosure.Panel must be rendered inside Disclosure')

  const {open, setOpen} = disclosureContextValue

  return (
    <CollapsibleRegion
      open={open}
      onBrowserReveal={() => setOpen(true)}
      {...rest}
      {...disclosureContextValue.getPanelProps({labelledBy})}
      ref={ref}
    >
      <div className={className} style={style}>
        {children}
      </div>
    </CollapsibleRegion>
  )
}
